import Service from '../service';
import Request from '../util/request';

export default class Auth {
    public verified: string | null = null;

    public timestamp: number = 0;
    public status: any = null;
    public loading: any = null;
    public session: any = {};
    public request: Request;

    constructor(public service: Service) {
        this.request = new Request();
    }

    private isAuthResponse(response: any) {
        return response && typeof response === 'object' && response.data && typeof response.data === 'object' && typeof response.code !== 'undefined';
    }

    private async checkSession() {
        let response: any = await this.request.post('/auth/check');
        if (this.isAuthResponse(response)) return response;
        return await this.request.post('/wiz/api/page.access/session_check');
    }

    public async init() {
        try {
            let response: any = await this.checkSession();
            if (!this.isAuthResponse(response)) {
                this.status = false;
                this.session = {};
                return this;
            }

            let { code, data } = response;
            let session = data.session || {};
            this.verified = session.verified || null;
            this.timestamp = new Date().getTime();
            this.session = session;
            this.status = code == 200 ? !!data.status : false;
        } catch (e) {
            this.verified = null;
            this.status = false;
            this.session = {};
        } finally {
            this.loading = true;
        }
        return this;
    }

    public async update() {
        while (this.loading === null) {
            await this.service.render(100);
        }

        let diff = new Date().getTime() - this.timestamp;
        if (diff > 1000 * 60) {
            this.loading = null;
            await this.init();
        }
    }

    public check: any = new Proxy(((root) => {
        let obj: any = () => {
            return this.status;
        }

        obj.root = root;
        return obj;
    })(this), {
        get(target, propKey) {
            let propValue: any = target.root.session[propKey];

            return (values: any = null) => {
                if (values === null) {
                    return true;
                }

                if (typeof values == 'boolean') {
                    if (values === propValue)
                        return true;
                    return false;
                }

                if (typeof values == 'string')
                    values = [values];

                if (values.indexOf(propValue) >= 0) {
                    return true;
                }

                return false;
            };
        }
    });

    public allow: any = new Proxy(((root) => {
        let obj: any = (redirect: any = null) => {
            if (root.check()) return true;
            if (redirect) location.href = redirect;
            return false;
        }

        obj.root = root;
        obj.check = root.check;
        return obj;
    })(this), {
        get(target, propKey) {
            return (values: any = null, redirect: any = null) => {
                if (target.check[propKey](values)) return true;
                if (redirect) location.href = redirect;
                return false;
            }
        }
    });

    public hash(password: string = '') {
        return this.service.crypto.SHA256(password).toString();
    }
}